var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq"},[_c('h2',[_vm._v("热门问答")]),_vm._l((_vm.list),function(item){return _c('div',{key:item.id || item.q,staticClass:"faq-item"},[_c('h3',[_vm._v(_vm._s(item.q))]),_c('p',[_vm._v(_vm._s(item.a))])])}),(_vm.loaded && !_vm.list.length)?_c('div',{staticClass:"empty"},[_vm._v("暂无问答")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }